import React, { useState } from "react";
import "./Action.css";
import Colors from "../../Helper/Colors";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  Input,
  Select,
  Spin,
  ConfigProvider,
  TimePicker,
} from "antd";
import { DatePicker as DatePickerJalali } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import InputSeperator from "../Components/input_seperator";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import moment from "jalali-moment";
// import FormatHelper from "../../Helper/FormatHelper";
import useAction from "../../hooks/useAction";
const { Option } = Select;

const CancelOrderModal = ({ cancelJob, setCancelJob }) => {
  const {
    getCancelReasons,
    getCancelQuestions,
    sendCancelAnswers,
    cancelReasons,
    cancelQuestions,
    setCancelQuestions,
    actionLoading,
    cancelLoadings,
  } = useAction();

  const [reason, setReason] = useState("");
  const [goToPlace, setGoToPlace] = useState(0);
  const [getFee, setGetFee] = useState(0);
  const [transferFee, setTransferFee] = useState("");
  const [checkFee, setCheckFee] = useState("");

  const selectedOrder = useSelector((state) => state.TechAppReducer.orderObj);

  const changeRadioQuestion = (e, question, answer_mode) => {
    let questions = [...cancelQuestions];
    let objIndex = questions.findIndex((obj) => obj.id === question.id);
    // remove true question
    if (
      answer_mode === "false_answer" &&
      question?.question?.true_question?.length > 0
    ) {
      questions = questions.filter(
        (filterQu) => filterQu.id !== question?.question?.true_question[0]?.id
      );
    }
    // remove false question
    if (
      answer_mode === "true_answer" &&
      question?.question?.false_question?.length > 0
    ) {
      questions = questions.filter(
        (filterQu) => filterQu.id !== question?.question?.false_question[0]?.id
      );
    }
    // add false answer
    if (answer_mode === "false_answer" && question?.question?.false_question) {
      if (
        !questions.find((o) => o.id === question.question.false_question[0].id)
      ) {
        question.question.false_question.forEach((falseQu) => {
          let newObj = { id: falseQu.id, question: falseQu, answer: null };
          if (falseQu.validation.includes("required")) {
            newObj.required = true;
            newObj.isValid = false;
          } else {
            newObj.required = false;
            newObj.isValid = true;
          }
          questions.splice(objIndex + 1, 0, newObj);
        });
      }
    }
    // add true answer
    if (answer_mode === "true_answer" && question?.question?.true_question) {
      if (
        !questions.find((o) => o.id === question.question.true_question[0].id)
      ) {
        question.question.true_question.forEach((trueQu) => {
          let newObj = { id: trueQu.id, question: trueQu, answer: null };
          if (trueQu.validation.includes("required")) {
            newObj.required = true;
            newObj.isValid = false;
          } else {
            newObj.required = false;
            newObj.isValid = true;
          }
          questions.splice(objIndex + 1, 0, newObj);
        });
      }
    }
    questions[objIndex].answer = e;
    questions[objIndex].isValid = true;
    setCancelQuestions(questions);
  };

  const changeInputQuestion = (e, question) => {
    let questions = [...cancelQuestions];
    let objIndex = questions.findIndex((obj) => obj.id === question.id);
    questions[objIndex].answer = e;
    if (e.length === 0) {
      questions[objIndex].isValid = false;
    } else if (e.length > 0) {
      questions[objIndex].isValid = true;
    }
    setCancelQuestions(questions);
  };

  const changeDateQuestion = (date, dateString, question) => {
    let questions = [...cancelQuestions];
    let objIndex = questions.findIndex((obj) => obj.id === question.id);
    questions[objIndex].answer = moment
      .from(dateString, "fa", "YYYY-MM-DD")
      .locale("fa")
      .format("YYYY-MM-DD");
    if (dateString) {
      questions[objIndex].isValid = true;
    }
    setCancelQuestions(questions);
  };

  const changeTimeQuestionFrom = (time, timeString, question) => {
    let questions = [...cancelQuestions];
    let objIndex = questions.findIndex((obj) => obj.id === question.id);
    questions[objIndex].answer = { from: timeString };
    if (questions[objIndex]?.answer?.to && timeString) {
      questions[objIndex].isValid = true;
    } else {
      questions[objIndex].isValid = false;
    }
    setCancelQuestions(questions);
  };

  const changeTimeQuestionTo = (time, timeString, question) => {
    let questions = [...cancelQuestions];
    let objIndex = questions.findIndex((obj) => obj.id === question.id);
    questions[objIndex].answer = {
      ...questions[objIndex].answer,
      to: timeString,
    };
    if (questions[objIndex]?.answer?.from && timeString) {
      questions[objIndex].isValid = true;
    } else {
      questions[objIndex].isValid = false;
    }
    setCancelQuestions(questions);
  };

  const submitCancel = () => {
    let array = [];
    cancelQuestions?.forEach((qu) => {
      array.push(qu.isValid);
    });
    if (array.includes(false)) {
      toast.warning("لطفا برای کنسل کردن به سوالات پاسخ دهید");
    } else {
      let postItems = {
        order_id: selectedOrder.id,
        action: 5,
        desc: "",
        go_to_place: goToPlace,
        get_paid: getFee,
      };
      cancelReasons.forEach((care) => {
        if (care.id === reason) {
          postItems.desc = care.reason;
          postItems.added_desc = care.reason;
        }
      });
      if (transferFee && transferFee > 0) {
        postItems.amount = parseFloat(transferFee);
      }
      if (checkFee && checkFee > 0) {
        postItems.check_fee = parseFloat(checkFee);
      }
      if (reason.length === 0) {
        toast.warning("دلیل کنسل کردن سفارش را انتخاب کنید");
      } else if (goToPlace === 1 && getFee === 1 && checkFee.length === 0) {
        toast.warning("لطفا مبلغی که دریافت کرده اید را وارد کنید");
      } else {
        if (cancelQuestions?.length > 0) {
          let answersData = {
            reason_id: reason,
            answers: [],
          };
          cancelQuestions.forEach((qu) => {
            answersData.answers.push({
              question_id: qu.id,
              answer: qu.answer,
            });
          });
          sendCancelAnswers(answersData, postItems);
        } else {
          // sendAction(postItems);
        }
      }
    }
  };

  useEffect(() => {
    getCancelReasons();
  }, []);

  return (
    <>
      <Modal
        ariaHideApp={false}
        open={cancelJob}
        onOk={submitCancel}
        onCancel={() => setCancelJob(false)}
        className="techapp-action-cancel-order"
        style={{ borderRadius: "6px", textAlign: "center" }}
        title={"دلیل کنسل کردن این کار چیست؟"}
        footer={[
          <>
            <Button
              disabled={actionLoading || cancelLoadings.sendAnswers}
              onClick={() => setCancelJob(false)}
              className="tech-app-reset-data-btns btn-text-black"
              style={{
                backgroundColor: "rgba(199, 199, 199, 0.322)",
                color: "black",
              }}
            >
              انصراف
            </Button>
            <Button
              loading={actionLoading || cancelLoadings.sendAnswers}
              onClick={submitCancel}
              className="tech-app-reset-data-btns btn-text-white"
              style={{ backgroundColor: Colors.royalBlue, color: "white" }}
            >
              ثبت
            </Button>
          </>,
        ]}
      >
        <div className="tech-app-cancel-order-modal">
          {/* cancel reason */}
          <Select
            disabled={cancelLoadings.getReasons}
            showSearch
            style={{ borderRadius: "6px" }}
            className="techapp-cancel-reason-select"
            placeholder={"انتخاب دلیل کنسلی"}
            onChange={(value) => {
              setReason(value);
              getCancelQuestions(value);
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {cancelReasons &&
              cancelReasons.map((reason, index) => (
                <Option
                  className="techapp-cancel-reason-options"
                  key={index}
                  value={reason.id}
                >
                  {reason.reason}
                </Option>
              ))}
          </Select>
          {/* render cancel Q&A */}
          {cancelLoadings.getQuestions ? <Spin /> : null}
          {!cancelLoadings.getQuestions &&
            cancelQuestions?.map((question, index) => (
              <div key={index} className="cancel_modal_questions_question_item">
                <span>{question.question.text}</span>
                {/* radio answer */}
                {question.question.answer_type === "radio" ? (
                  <div className="cancel_modal_questions_question_item_radio_actions">
                    <Button
                      onClick={() =>
                        changeRadioQuestion(
                          question.question.true_text,
                          question,
                          "true_answer"
                        )
                      }
                      id={
                        question.answer === question.question.true_text
                          ? "cancel_modal_questions_question_item_radio_action_selected"
                          : ""
                      }
                    >
                      {question.question.true_text}
                    </Button>
                    <Button
                      onClick={() =>
                        changeRadioQuestion(
                          question.question.false_text,
                          question,
                          "false_answer"
                        )
                      }
                      id={
                        question.answer === question.question.false_text
                          ? "cancel_modal_questions_question_item_radio_action_selected"
                          : ""
                      }
                    >
                      {question.question.false_text}
                    </Button>
                  </div>
                ) : null}
                {/* input answer */}
                {question.question.answer_type === "text" ||
                question.question.answer_type === "tell" ? (
                  <Input
                    value={question.answer}
                    placeholder={
                      question.placeholder
                        ? question.placeholder
                        : "در این قسمت وارد کنید"
                    }
                    onChange={(e) =>
                      changeInputQuestion(e.target.value, question)
                    }
                    type={question.question.answer_type}
                  />
                ) : null}
                {/* date answer */}
                {question.question.answer_type === "date" ? (
                  <ConfigProvider locale={fa_IR} direction="rtl">
                    <DatePickerJalali
                      onChange={(date, dateString) =>
                        changeDateQuestion(date, dateString, question)
                      }
                      style={{
                        width: "100%",
                        border: "1px solid #d9d9d9",
                        margin: "12px 0 3px 0",
                        borderRadius: "6px",
                      }}
                    />
                  </ConfigProvider>
                ) : null}
                {/* time answer */}
                {question.question.answer_type === "time" ? (
                  <div className="cancel_modal_questions_question_item_time_actions">
                    <TimePicker
                      placeholder="از"
                      onChange={(time, timeString) =>
                        changeTimeQuestionFrom(time, timeString, question)
                      }
                      defaultOpenValue={moment("00:00", "HH:mm")}
                      format={"HH:mm"}
                      suffixIcon={null}
                      clearIcon={false}
                    />
                    <TimePicker
                      placeholder="تا"
                      format={"HH:mm"}
                      onChange={(time, timeString) =>
                        changeTimeQuestionTo(time, timeString, question)
                      }
                      defaultOpenValue={moment("00:00", "HH:mm")}
                      suffixIcon={null}
                      clearIcon={false}
                    />
                  </div>
                ) : null}
              </div>
            ))}
          {/* go to place buttons */}
          <div
            style={{ marginTop: "10px" }}
            className="cancel_modal_pay_options"
          >
            <Button
              onClick={() => {
                setGoToPlace(0);
                setTransferFee("");
                setCheckFee("");
                setGetFee(null);
              }}
              disabled={actionLoading || cancelLoadings.sendAnswers}
              style={
                goToPlace === 0
                  ? { backgroundColor: Colors.warning }
                  : { backgroundColor: "white", color: Colors.secondary }
              }
            >
              مراجعه حضوری نداشتم
            </Button>
            <Button
              onClick={() => {
                setGoToPlace(1);
                setGetFee(0);
              }}
              disabled={actionLoading || cancelLoadings.sendAnswers}
              style={
                goToPlace === 1
                  ? { backgroundColor: Colors.warning }
                  : { backgroundColor: "white", color: Colors.secondary }
              }
            >
              مراجعه حضوری داشتم
            </Button>
          </div>
          {/* get fee buttons */}
          {goToPlace === 1 && (
            <div
              style={{ marginTop: "10px" }}
              className="cancel_modal_pay_options"
            >
              <Button
                disabled={actionLoading || cancelLoadings.sendAnswers}
                onClick={() => {
                  setGetFee(0);
                  setTransferFee("");
                  setCheckFee("");
                }}
                style={
                  getFee === 0
                    ? { backgroundColor: Colors.warning }
                    : { backgroundColor: "white", color: Colors.secondary }
                }
              >
                ایاب ذهاب و کارشناسی دریافت نشد
              </Button>
              <Button
                onClick={() => setGetFee(1)}
                style={
                  getFee === 1
                    ? { backgroundColor: Colors.warning }
                    : { backgroundColor: "white", color: Colors.secondary }
                }
              >
                ایاب ذهاب و کارشناسی دریافت شد
              </Button>
            </div>
          )}
          {/* fee inputs */}
          {getFee === 1 && (
            <>
              {/* <InputSeperator
                value={transferFee}
                setValue={setTransferFee}
                className={"ant-input"}
                placeHolder="مبلغ ایاب ذهاب را از ۱ تا ۸۰ هزارتومان وارد کنید"
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  textAlign: "center",
                  borderRadius: "6px",
                  minHeight: "32px",
                  margin: "10px 0",
                }}
              /> */}
              <InputSeperator
                value={checkFee}
                setValue={setCheckFee}
                className={"ant-input"}
                placeHolder="مبلغی که بابت کارشناسی و ایاب ذهاب دریافت کرده‌اید را وارد کنید"
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  textAlign: "center",
                  borderRadius: "6px",
                  margin: "10px 0",
                  minHeight: "32px",
                }}
              />
            </>
          )}
        </div>
      </Modal>
    </>
  );
};
export default CancelOrderModal;
